import Link from "@/components/common/Link";
import {
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalOverlay,
  Text,
  Alert,
  AlertIcon,
  AlertTitle,
} from "@chakra-ui/react";
import React from "react";
import { DollarSign } from "react-feather";
import { useTranslation } from "react-i18next";
import useSWR from "swr";

interface Props {
  errorMessage: string;
  isOpen: boolean;
  onClose: () => void;
}

const LimitExceedingModal: React.FC<Props> = ({
  errorMessage,
  isOpen,
  onClose,
}: Props) => {
  const { t } = useTranslation();
  const { data: subscription } = useSWR("/subscription");
  return (
    <Modal
      size="xl"
      motionPreset="slideInBottom"
      isOpen={isOpen}
      onClose={onClose}
      preserveScrollBarGap
    >
      <ModalOverlay>
        <ModalContent>
          <ModalCloseButton />
          <ModalBody textAlign="center">
            <Alert status="error" mb={5} mt={10}>
              <AlertIcon />
              <AlertTitle> {t("payments.limitExceeding")}</AlertTitle>
            </Alert>
            <Text fontWeight="500">{t(`payments.${errorMessage}`)}</Text>
            {!subscription?.organizationId && (
              <Link to="/payments">
                <Button
                  leftIcon={<DollarSign />}
                  variant="solid"
                  size="md"
                  mt={5}
                  mb={3}
                >
                  {t("payments.goToPayments")}
                </Button>
              </Link>
            )}
            {subscription?.organizationId && (
              <Text px={2} fontSize="1.125rem" mt="1.25rem" opacity="0.7">
                {t("payments.limitFromOrganizationExceeding")}
              </Text>
            )}
          </ModalBody>
        </ModalContent>
      </ModalOverlay>
    </Modal>
  );
};

export default LimitExceedingModal;
